module.exports = __webpack_public_path__ + "img/1-2.6cad8fa9.jpg";